<template>
  <div class="popup z-index-10-fg confirmation small-popup add-interaction-popup">
    <div class="popup-content">
      <div class="popup-header">
        <h2>Filter</h2>
        <img src="../assets/close.svg" alt="" class="popup-close" @click="$emit('closePopup')" />
      </div>
      <div :class="{ 'popup-body': true }">
        <Dropdown
          :options="[
            { text: 'In Process Only', value: false },
            { text: 'Show Completed', value: true },
          ]"
          label="Complete"
          v-model="filters.complete"
          class="input-item large-item" />

        <Dropdown :options="salespeopleWithAll" label="Salesperson" v-model="filters.salespersonId" class="input-item large-item" />
        <Dropdown
          :options="[
            { text: 'Show All', value: false },
            { text: 'Delivery Leads Only', value: true },
          ]"
          label="Delivery"
          v-model="filters.delivery"
          class="input-item large-item" />
        <Dropdown
          :options="[
            { text: 'All', value: 'All' },
            { text: 'Rickreall', value: 'Rickreall' },
            { text: 'Tumwater', value: 'Tumwater' },
            { text: 'Swift River', value: 'Swift River' },
          ]"
          label="Location"
          v-model="filters.location"
          class="input-item large-item" />
        <MultiDropdown :options="scoreOptions" label="Score" v-model="filters.scores" :showSelectAll="true" class="input-item large-item" />
        <h3>Date Range</h3>
        <div class="primary-input input-item small-item">
          <input type="date" v-model="filters.dateFrom" />
          <label>From</label>
        </div>
        <div class="primary-input input-item small-item">
          <input type="date" v-model="filters.dateTo" />
          <label>To</label>
        </div>
      </div>
      <div class="popup-footer">
        <button @click="resetFilters()" class="text-btn">reset</button>
        <button class="square-btn" @click="$emit('closePopup')">Save</button>
      </div>
    </div>
  </div>
  <div class="screen-overlay-gray z-index-10-bg"></div>
</template>

<script>
import Dropdown from './inputs/Dropdown.vue';
import MultiDropdown from './inputs/MultiDropdown.vue';
import useLeadsQuery from '@/composables/useLeadsQuery';
import useUsersQuery from '@/composables/useUsersQuery';
import useCurrentUser from '@/composables/useCurrentUser';

export default {
  name: 'Reminder',
  emits: ['closePopup'],
  components: {
    Dropdown,
    MultiDropdown,
  },
  setup() {
    const { salespeople } = useUsersQuery();

    const scoreOptions = [
      { key: 'hot', value: 'Hot' },
      { key: 'warm', value: 'Warm' },
      { key: 'cool', value: 'Cool' },
      { key: 'dead', value: 'Dead' },
    ];

    const { user } = useCurrentUser();

    return {
      salespeople,
      scoreOptions,
      filters: useLeadsQuery.filters,
      user,
    };
  },
  computed: {
    salespeopleWithAll() {
      return [{ text: 'All', value: null }, ...this.salespeople.map((salesperson) => ({ text: salesperson.DISPLAYNAME, value: salesperson.USERID }))];
    },
  },
  methods: {
    resetFilters() {
      this.filters.complete = false;
      this.filters.salespersonId = this.user.userid;
      this.filters.delivery = false;
      this.filters.location = 'All';
      this.filters.scores = ['hot', 'warm', 'cool']; // Reset to default: exclude dead leads
      this.filters.dateFrom = null;
      this.filters.dateTo = null;
      this.$emit('closePopup');
    },
  },
  watch: {
    'filters.location': {
      handler(newVal) {
        if (newVal != 'All') {
          this.filters.salespersonId = null;
        }
      },
    },
    'filters.salespersonId': {
      handler(newVal) {
        if (newVal != null) {
          this.filters.location = 'All';
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.add-interaction-popup {
  width: 25rem;

  .popup-body {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 1.5rem 1rem;

    .complete-lead-section {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      gap: 1.5rem 1rem;
    }

    .input-item {
      min-width: 20rem;
      flex: 1 0 45%;

      &.small-item {
        min-width: 5rem;
        flex: 1 0 10%;
      }

      &.large-item {
        min-width: 20rem;
        flex: 1 0 90%;
      }

      &.medium-item {
        min-width: 5rem;
        flex: 1 0 25%;
      }
    }
  }
}
</style>
